import { connect } from "react-redux";
import CreateNew from "../../components/survey/create";
import getKpiList from "../../redux/actions/surveyActions";
import {
	loadSurveyProgress,
	removeSurveyProgress,
	createElement,
	addStepSurvey,
	getSector,
	getLocation,
} from "../../redux/actions/surveyActions";

const mapStateToProps = (state, ownProps) => {
	let locationList;
	const model = state.survey.surveyManager.surveyProgress.model || [];
	if(model.length > 0){
		const firstModel = model[0] || {}
		locationList = firstModel.locations;
	}
	return {
		surveyProgress: state.survey.surveyManager.surveyProgress,
		currentSurvey: state.survey.surveyManager.currentSurvey,
		//locatonList: state.survey.surveyManager.locatonList,

		locatonList: locationList,
		sectorList: state.survey.surveyManager.sectorList,
		assortmentClient: state.survey.surveyManager.assortmentClient,
		currentClient: state.currentClient || {}
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		// getSurveyList: surveyList => {
		// 	dispatch(getSurveyList(surveyList));
		// },
		createElement: data => {
			dispatch(createElement(data));
		},
		getSector: data => {
			dispatch(getSector(data));
		},
		addStepSurvey: survey => {
			dispatch(addStepSurvey(survey));
		},
		getLocation: (idClient, idRetailer) => {
			dispatch(getLocation(idClient, idRetailer));
		},
		getKpiList: () => {
			dispatch(getKpiList());
		},

		loadSurveyProgress: data => {
			dispatch(loadSurveyProgress(data));
		},
		removeSurveyProgress: data => {
			dispatch(removeSurveyProgress());
		},
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(CreateNew);



// WEBPACK FOOTER //
// src/pages/survey/CreateNew.js